import * as React from 'react';
/**
 * Krok FLK1 — SPUSTI `onChange`, AZ KDYZ SE `value` OPRAVDU ZMENI (ne pri mountu).
 *
 * Vzor „prevezmi hodnotu z rodice do lokalniho stavu" se psal jako
 * `useEffect(() => setDraft(value), [value])`. Ten efekt ale bezi i pri
 * MOUNTU — a pasivni efekty React spousti az po commitu. Kdo stihl napsat
 * znak mezi commitem a efektem (pomaly stroj, test pod zatezi brany), tomu
 * efekt rozepsany text prepsal zpet. Pocatecni hodnotu uz ma `useState(value)`,
 * takze pri mountu neni co propisovat.
 *
 * Porovnani je `Object.is` nad `key` — pro hodnoty, ktere rodic posila jako
 * novy objekt pri kazdem renderu, predej klic (napr. `String(value ?? '')`).
 */
export function useOnChange(key, onChange) {
    const last = React.useRef(key);
    const callback = React.useRef(onChange);
    callback.current = onChange;
    React.useEffect(() => {
        if (Object.is(last.current, key))
            return;
        last.current = key;
        callback.current(key);
    }, [key]);
}
//# sourceMappingURL=use-on-change.js.map